import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LoginService } from '@login/services/login.service';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as loginActions from '@login/ngrx/login.actions';
import { TranslateService } from '@ngx-translate/core';
import { OAuth2TokensDto } from '@services/authentication/model/oAuth2TokensDto';
import { ToastrService } from 'ngx-toastr';
import { catchError, map, of, switchMap, tap } from 'rxjs';
import { SharedService } from '@shared/shared.service';
import {WebOwnProfileModel} from "@services/back-office/model/webOwnProfileModel";

@Injectable()
export class LoginEffects {
  /** Login */
  login$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(loginActions.LoginActionTypes.Login),
      switchMap((action: loginActions.Login) => {
        return this.loginService.logIn(action.payload).pipe(
          map((response: OAuth2TokensDto) => new loginActions.LoginSuccess(response)),
          catchError((error: HttpErrorResponse) => of(new loginActions.LoginFailure(error))),
        );
      })
    );
  });

  loginFailure$ = createEffect(() => {
      return this.actions$.pipe(
        ofType(loginActions.LoginActionTypes.LoginFailure),
        tap((action: loginActions.LoginFailure) => {
          SharedService.showErrorWithTitle(
            this.translateService,
            this.toastrService,
            `responseErrors.${action.payload.error.message}`
          );
        })
      );
    },
    {dispatch: false}
  );

  /** Load Current User */
  loadCurrentUser$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(loginActions.LoginActionTypes.LoadUser),
      switchMap(() => {
        return this.loginService.loadCurrentUser().pipe(
          map((response: WebOwnProfileModel) => new loginActions.LoadUserSuccess(response)),
          catchError((error: HttpErrorResponse) => of(new loginActions.LoadUserFailure(error))),
        );
      })
    );
  });

  loadCurrentUserFailure$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(loginActions.LoginActionTypes.LoadUserFailure),
      tap((action: loginActions.LoadUserFailure) => {
        SharedService.showErrorWithTitle(
          this.translateService,
          this.toastrService,
          `responseErrors.${action.payload.error.message}`
        );
      })
    );
  },
    {dispatch: false}
  );

  constructor(
    private actions$: Actions,
    private loginService: LoginService,
    private translateService: TranslateService,
    private toastrService: ToastrService,
  ) {}
}
